import { highlighter } from "./highlighter.js";

export const logger = {
  error: (...args: unknown[]) => {
    console.log(highlighter.error(args.join(" ")));
  },
  warn: (...args: unknown[]) => {
    console.log(highlighter.warn(args.join(" ")));
  },
  success: (...args: unknown[]) => {
    console.log(highlighter.success(args.join(" ")));
  },
  info: (...args: unknown[]) => {
    console.log(highlighter.info(args.join(" ")));
  },
  log: (...args: unknown[]) => {
    console.log(args.join(" "));
  },
  break: () => {
    console.log("");
  },
};
